import { useEffect, useState } from "react";
import { workspace } from "@/store/modules/workspace.ts";
import { useDispatch, useSelector } from "react-redux";
import BaseTable, { FieldType } from "../table/BaseTable.tsx";
import { RootState } from "@/store/modules";
import { RouteConstant } from "@/util/constant/RouteConstant.ts";
import { useNavigate } from "react-router-dom";
import { application } from "@/store/modules/application.ts";
import { HelpUtil } from "@/util/HelpUtil.ts";
import NavBarHeading from "@/components/menu/NavBarHeading.tsx";
import { base } from "@/store/modules/base.ts";
import { ModalConstant } from "@/util/constant/ModalConstant.ts";
import NewApplicationModal from "@/components/modal/NewApplicationModal.tsx";
import DashboardLayout from "@/layout/DashboardLayout.tsx";

export default function Dashboard() {
  const dispatch = useDispatch<any>();
  const [isDropdownActive, setIsDropdownActive] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const workSpaceState = useSelector((state: RootState) => state.workspace);
  const authState = useSelector((state: RootState) => state.auth);

  const navigate = useNavigate();

  const formattedWorkspace = workSpaceState.workspaceById.map((it) => {
    return {
      ...it,
      workspaceUpdatedAt: HelpUtil.formatDate(it.workspaceUpdatedAt),
      workspaceCreatedAt: HelpUtil.formatDate(it.workspaceCreatedAt),
    };
  });

  const reversedApplications = [...formattedWorkspace].reverse();

  const handleDropdownClick = () => {
    setIsDropdownActive(!isDropdownActive);
  };

  useEffect(() => {
    dispatch(
      workspace.action.readWorkSpaceByUserId({
        userId: authState.userInfo?.userId,
      })
    );
  }, []);

  const fields: FieldType[] = [
    {
      label: "WorkSpace Name",
      key: "workspaceName",
      onClick: (data) => {
        dispatch(workspace.mutation.setSelectedWorkspace(data));
        dispatch(application.mutation.selectedApplication(null));
        dispatch(application.mutation.setSelectedApplicationsByWorkSpaceId([]));
        // dispatch(application.action.readByWorkspaceId({applicationWorkspaceId: data?.workspaceId}))
        dispatch(application.action.readApplication());
        navigate(RouteConstant.dashboard.applicationWorkspace.path);
      },
    },
    { label: "Description", key: "workspaceDescription" },
    { label: "Status ", key: "workspaceStatus" },
    { label: "Created At", key: "workspaceCreatedAt" },
    { label: "Updated At", key: "workspaceUpdatedAt" },
  ];

  return (
    <DashboardLayout>
      <section
        className="app-content-dashboard"
        style={{ backgroundColor: "white" }}
      >
        <div className="title-wrapper">
          <div className="margin-bottom">
            <h5
              style={{
                paddingLeft: "10px",
              }}
            >
              WorkSpaces
            </h5>
          </div>
          <NavBarHeading />
        </div>
        <section className="project-table-wrapper">
          <div style={{ display: "flex", gap: "1rem" }}>
            <button
              className="button"
              onClick={() => {
                dispatch(
                  base.mutation.setModalOptions({
                    show: true,
                    component: ModalConstant.createWorkSpace,
                  })
                );
              }}
            >
              Create New Workspace
            </button>
          </div>
          <BaseTable
            title={"Workspace"}
            component={""}
            items={reversedApplications ?? []}
            refreshPage={handleDropdownClick}
            showToast={false}
            loader={workSpaceState.loading}
            onCellClickAction={(value) => console.log("Hello, world", value)}
            fields={fields}
            actions={{ view: true }}
            rowOptions={[
              {
                optionName: "Create Application",
                onClick: (data) => {
                  dispatch(workspace.mutation.setSelectedWorkspace(data));

                  setShowModal(true);
                },
                optionStyle: { fontSize: 12 },
              },
              {
                optionName: "View Workspace",
                onClick: (data) => {
                  dispatch(workspace.mutation.setSelectedWorkspace(data));
                  dispatch(application.mutation.selectedApplication(null));
                  dispatch(
                    application.action.readByWorkspaceId({
                      applicationWorkspaceId: data?.workspaceId,
                    })
                  );
                  navigate(RouteConstant.dashboard.applicationWorkspace.path);
                },
                optionStyle: { fontSize: 12 },
              },
              {
                optionName: "Edit Workspace",
                onClick: (data) => {
                  dispatch(
                    base.mutation.setModalOptions({
                      show: true,
                      component: ModalConstant.createWorkSpace,
                      payload: data,
                    })
                  );
                  dispatch(workspace.mutation.setSelectedWorkspace(data));
                },
                optionStyle: { fontSize: 12 },
              },
              {
                optionName: "Delete Workspace",
                onClick: (data) => {
                  dispatch(workspace.mutation.setSelectedWorkspace(data));
                  dispatch(
                    base.mutation.setModalOptions({
                      show: true,
                      component: ModalConstant.deleteWorkSpace,
                      payload: data,
                    })
                  );
                },
                optionStyle: { fontSize: 12 },
              },
            ]}
          />
          {showModal && (
            <NewApplicationModal
              show={showModal}
              onClose={() => setShowModal(false)}
            />
          )}
          <div className="margin-top">
            <div className="table-wrapper"></div>
          </div>
        </section>
      </section>
    </DashboardLayout>
  );
}
